module.exports = __webpack_public_path__ + "static/media/Group 25121.aac9dc89.svg";